//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import User from '~/components/User.vue';
import constant from '~/const';
import Filters from './UserP2PReviewsFilters.vue';
import tableConfig from './tableConfig';
import Modal from './Modal.vue';

export default {
  components: {
    Filters,
    User,
    Modal,
  },

  props: { username: { type: String, default: '' } },

  data() {
    return {
      tableConfig,
      loader: false,
      constant,
      feedbackHistoryModal: {
        show: false,
        data: [],
        id: undefined,
      },
      editingFeedback: {
        modal: false,
        loader: false,
        data: {
          comment: '',
          influence: '',
          feedbackId: 0,
        },
      },
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('userP2PReviews', ['page', 'pages', 'data', 'sort']),
  },

  async mounted() {
    await this.loadData({
      username: this.username,
    });
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setGeneralProgress',
      'setSuccessNotification',
      'setErrorNotification',
      'confirmAction',
    ]),
    ...mapActions('userP2PReviews', {
      loadDataAction: 'loadData',
      getFeedbackHistoryAction: 'getFeedbackHistory',
      setPageAction: 'setPage',
      setSortAction: 'setSort',
      editFeedback: 'editFeedback',
      deleteFeedback: 'deleteFeedback',
    }),

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      this.loader = true;
      await this.loadDataAction(data);
      this.setGeneralProgress(false);
      this.loader = false;
    },

    async getHistory(id) {
      this.setGeneralProgress(true);
      this.feedbackHistoryModal.data = await this.getFeedbackHistoryAction({ feedbackId: id });
      this.feedbackHistoryModal.id = id;
      this.feedbackHistoryModal.show = true;
      this.setGeneralProgress(false);
    },

    applyFilters() {
      const { page } = this;
      if (page > 1) {
        this.setPageAction(1);
        this.$router.replace({ query: {} });
      }

      this.loadData({
        username: this.username,
      });
    },

    applySort(data) {
      this.setSortAction(data);
      this.loadData({
        username: this.username,
      });
    },

    setPage(value) {
      this.setPageAction(value);

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData({
        extendedRequestData,
        username: this.username,
      });
    },

    classTypeOfInfluence(type) {
      if (type === 'Positive') return 'success--text';
      if (type === 'Negative') return 'error--text';
      return '';
    },

    editFeedbackState(row) {
      const { comment, influence, id } = row;
      this.editingFeedback.data.comment = comment;
      this.editingFeedback.data.influence = influence;
      this.editingFeedback.data.feedbackId = id;
      this.editingFeedback.modal = true;
    },

    async applyEditFeedback() {
      const { comment, influence, feedbackId } = this.editingFeedback.data;
      this.setGeneralProgress(true);
      this.editingFeedback.loader = true;
      await this.editFeedback({
        comment,
        influence,
        feedbackId,
      });
      await this.loadData({
        username: this.username,
      });
      this.editingFeedback.modal = false;
      this.setGeneralProgress(false);
      this.editingFeedback.loader = false;
      this.setSuccessNotification('Feedback edited');
    },

    deleteFeedbackMessage(id) {
      this.confirmAction({
        text: 'Are you sure you want to delete feedback?',
        callback: async () => {
          this.setGeneralProgress(true);
          await this.deleteFeedback(id);
          await this.loadData({
            username: this.username,
          });
          this.setGeneralProgress(false);
          this.setSuccessNotification('Feedback deleted');
        },
      });
    },
  },
};
